<!-- OPPWA widget mount point -->
<div class="py-5" #paymentContainer></div>

<!-- Loading -->
@if (widgetState().isLoading) {
  <div class="flex flex-col justify-center items-center h-[200px]">
    <nz-spin nzSimple nzSize="large"></nz-spin>
    <p class="mt-6 text-gray-500">{{ getLoadingMessage() }}</p>
  </div>
}

<!-- Error -->
@if (widgetState().error) {
  <div class="flex flex-col justify-center items-center h-[200px] gap-4">
    <p class="text-red-500 text-center">{{ widgetState().error }}</p>
    <button nz-button nzSize="large" nzType="primary" (click)="retryPaymentWidget()">Retry Payment</button>
  </div>
}
